<template>
  <div>
    <img class="pointer" style="width: 100%;" src="@/assets/purchase/banner.png" @click="$login">
    <text-left
      :text-left="{
        height: 410,
        title: '提前规划您的采购费用支出',
        desc: '仪表盘汇总显示了系统内等待审核或等待支付的采购账单，帮助您更好的了解即将发生或者可能产生逾期的费用，提前规划您的采购费用支出。',
        textWidth: 800,
        left: false,
        imgWidth: 250,
        img: require('@/assets/purchase/img2.png')
      }"/>
    <text-left
      :text-left="{
        height: 510,
        title: '创建重复采购账单',
        desc: '对于重复性的采购业务，筝鸣支持预设重复采购单。届时，系统会按照预设的计划自动创建采购单。同时，如果新建的采购单与历史采购单相似，只需复制一张历史采购账单，然后做一些数据修改即可。',
        textWidth: 680,
        left: true,
        imgWidth: 350,
        img: require('@/assets/purchase/img1.png')
      }"/>
    <part-list :part-list="list" />
    <Ready />
  </div>
</template>

<script>
import Ready from '@/components/Ready'
import PartList from '@/components/PartList'
import TextLeft from '@/components/TextLeft'
export default {
  name: 'Purchase',
  components: { Ready, PartList, TextLeft },
  data() {
    return {
      list: [
        {
          img: require('@/assets/common/fapiao.png'),
          title: '发票管理',
          desc: '跟踪每笔业务的发票开具或收到状态、认证和抵扣状态',
          path: '/bill'
        },
        {
          img: require('@/assets/common/xiaoshou.png'),
          title: '销售账单管控',
          desc: '跟踪销售账单收款状态，牢牢掌控应收账款',
          path: '/sale'
        },
        {
          img: require('@/assets/common/guanli.png'),
          title: '管理仪表盘',
          desc: '通过仪表盘监控企业资金流、应收、应付、费用状况',
          path: '/dashboard'
        },
        {
          img: require('@/assets/common/feiyong.png'),
          title: '费用报销管理',
          desc: '员工随时随地登录系统，完成费用报销申请与审批',
          path: '/reimbursement'
        },
        {
          img: require('@/assets/common/guding.png'),
          title: '固定资产',
          desc: '集中管理，轻松维护您的固定资产',
          path: '/estate'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
